import {
    IValidation,
    email,
    maxLength,
    regex,
    required,
    secureValue,
} from '@vfde-brix/ws10/validation';

const INPUT_MAX_LENGTH = 50;
const HOUSENUMBER_MAX_LENGTH = 10;
const INVALID_CHARS_REGEX = /\?|=|\(|\)|"|§|\$|%/g;

export const cityValidations: IValidation[] = [
    { errorKey: 'requiredCity', validator: required },
    { errorKey: 'maxLength50', validator: maxLength, maxLength: INPUT_MAX_LENGTH },
    { errorKey: 'invalidCharacters', validator: regex, regex: INVALID_CHARS_REGEX },
];

export const streetValidations: IValidation[] = [
    { errorKey: 'requiredStreet', validator: required },
    { errorKey: 'maxLength50', validator: maxLength, maxLength: INPUT_MAX_LENGTH },
    { errorKey: 'invalidCharacters', validator: regex, regex: INVALID_CHARS_REGEX },
];

export const houseNumberValidations: IValidation[] = [
    { errorKey: 'requiredNumber', validator: required },
    { errorKey: 'maxLengthHouseNr', validator: maxLength, maxLength: HOUSENUMBER_MAX_LENGTH },
    { errorKey: 'invalidCharacters', validator: regex, regex: INVALID_CHARS_REGEX },
];

export const defaultValidation: IValidation[] = [
    { errorKey: 'required', validator: required },
    { errorKey: 'invalidCharacters', validator: secureValue },
    { errorKey: 'maxLength50', validator: maxLength, maxLength: INPUT_MAX_LENGTH },
];

export const emailValidation: IValidation[] = [
    ...defaultValidation,
    { errorKey: 'email', validator: email },
];
